import {
  Box,
  IconButton,
  MenuItem,
  Select,
  Stack,
  TablePagination,
  Typography,
} from '@mui/material'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import { DEFAULT_ROWS, ROWS_PER_PAGE_OPTIONS } from '../constants'

function CompactReportPagination({
  pagination,
  onPageChange,
  onRowsPerPageChange,
  rowsPerPageOptions = ROWS_PER_PAGE_OPTIONS,
}) {
  const total = pagination?.total || 0
  const limit = pagination?.limit || DEFAULT_ROWS
  const page = pagination?.page || 1
  const pageCount = Math.max(1, Math.ceil(total / limit))
  const from = total === 0 ? 0 : (page - 1) * limit + 1
  const to = total === 0 ? 0 : Math.min(page * limit, total)

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      spacing={1}
      sx={{ pt: 1, minHeight: 32 }}
    >
      <Stack direction="row" alignItems="center" spacing={0.75} sx={{ minWidth: 0 }}>
        <Typography variant="caption" color="text.secondary" sx={{ fontSize: '11.5px', whiteSpace: 'nowrap' }}>
          Rows:
        </Typography>
        <Select
          size="small"
          value={limit}
          onChange={(e) => onRowsPerPageChange(parseInt(e.target.value, 10))}
          sx={{
            fontSize: '11.5px',
            '.MuiSelect-select': { py: 0.25, pl: 1, pr: '24px !important' },
            minWidth: 56,
          }}
        >
          {rowsPerPageOptions.map((option) => (
            <MenuItem key={option} value={option} sx={{ fontSize: '12px' }}>
              {option}
            </MenuItem>
          ))}
        </Select>
      </Stack>

      <Stack direction="row" alignItems="center" spacing={0.25} sx={{ flexShrink: 0 }}>
        <Typography variant="caption" color="text.secondary" sx={{ fontSize: '11.5px', whiteSpace: 'nowrap', mr: 0.25 }}>
          {from}–{to} of {total}
        </Typography>
        <IconButton
          size="small"
          aria-label="Previous page"
          disabled={page <= 1}
          onClick={() => onPageChange(page - 1)}
          sx={{ p: 0.5 }}
        >
          <ChevronLeftIcon sx={{ fontSize: 20 }} />
        </IconButton>
        <IconButton
          size="small"
          aria-label="Next page"
          disabled={page >= pageCount}
          onClick={() => onPageChange(page + 1)}
          sx={{ p: 0.5 }}
        >
          <ChevronRightIcon sx={{ fontSize: 20 }} />
        </IconButton>
      </Stack>
    </Stack>
  )
}

function ReportTablePagination({
  pagination,
  onPageChange,
  onRowsPerPageChange,
  compact = false,
  rowsPerPageOptions = ROWS_PER_PAGE_OPTIONS,
}) {
  if (compact) {
    return (
      <Box sx={{ width: '100%' }}>
        <CompactReportPagination
          pagination={pagination}
          onPageChange={onPageChange}
          onRowsPerPageChange={onRowsPerPageChange}
          rowsPerPageOptions={rowsPerPageOptions}
        />
      </Box>
    )
  }

  return (
    <TablePagination
      component="div"
      rowsPerPageOptions={ROWS_PER_PAGE_OPTIONS}
      count={pagination?.total || 0}
      rowsPerPage={pagination?.limit || DEFAULT_ROWS}
      page={(pagination?.page || 1) - 1}
      onPageChange={(_, nextPage) => onPageChange(nextPage + 1)}
      onRowsPerPageChange={(e) => onRowsPerPageChange(parseInt(e.target.value, 10))}
    />
  )
}

export default ReportTablePagination
